<template>
  <article id="map-page" class="column content page">
    <div id="map">
      <h1>MAP</h1>
      <img src="/static/img/rmg-map.png" alt="Map of the selected artworks at Ace Hotel London">
    </div>
  </article>
</template>

<script>
export default {
  name: 'map-page',
  beforeCreate: function () {
    document.body.className = 'map-page'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/MapPage.vue?8a0ff410